<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar tab='1'></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="info-content">
              <div class="info-content-fields">
                  <el-form ref="form" :model="contentData" :show-message="false">
                      <div class="el-form-item inline-items">
                        <label class="el-form-item__label">
                          活动负责人申请开放时间：
                        </label>
                          <div class="">
                            <label>每个季度第</label>
                            <el-form-item required prop="applyMonth">
                              <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="12" v-model="contentData.applyMonth" :disabled="!editVisible"></el-input-number>
                            </el-form-item>
                            <label>个月</label>
                            <el-form-item required prop="applyDay">
                              <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="31" v-model="contentData.applyDay" :disabled="!editVisible"></el-input-number>
                            </el-form-item>
                            <label>号0点。</label>
                          </div>
                      </div>
                      <div class="el-form-item inline-items">
                        <label class="el-form-item__label">
                          直线经理审批截止时间：
                        </label>
                          <div class="">
                          <label>每个季度第</label>
                          <el-form-item required prop="approveManageMonth">
                            <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="12" v-model="contentData.approveManageMonth" :disabled="!editVisible"></el-input-number>
                          </el-form-item>
                          <label>个月</label>
                          <el-form-item required prop="approveManageDay">
                            <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="31" v-model="contentData.approveManageDay" :disabled="!editVisible"></el-input-number>
                          </el-form-item>
                          <label>号24点。</label>
                          </div>
                      </div>
                      <div class="el-form-item inline-items">
                        <label class="el-form-item__label">
                          VP-1审批截止时间：
                        </label>
                          <div class="">
                          <label>每个季度第</label>
                          <el-form-item required prop="approveVpMonth">
                            <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="12" v-model="contentData.approveVpMonth" :disabled="!editVisible"></el-input-number>
                          </el-form-item>
                          <label>个月</label>
                          <el-form-item required prop="approveVpDay">
                            <el-input-number :controls="false" controls-position="right" :precision="0" :min="1" :max="31" v-model="contentData.approveVpDay" :disabled="!editVisible"></el-input-number>
                          </el-form-item>
                          <label>号24点。</label>
                          </div>
                      </div>
                  </el-form>                
              </div>
          </div>
          <div class="operate">
            <div>
              <el-button type="primary" plain v-show="!editVisible" @click="handleEditClick()">编辑</el-button>
              <el-button type="primary" plain v-show="editVisible" @click="handleCancelEditClick()">取消</el-button>
              <el-button type="primary" v-show="editVisible" @click="handleEditConfirmClick()">确认</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认保存 -->
    <common-confirm :dialogVisiable.sync="confirmEditSaveVisible" :confirm="handlerEditSaveConfirmOK">
      <div>
        <span>确认更改季度申请开放周期？</span>
      </div>
    </common-confirm>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import sysdateconfig from '@/api/sysmanagement/sysdateconfig';
import LeftBar from '../LeftBar';

export default {
  components: {
    LeftBar
  },
  data() {
    return {     
      editVisible: false, 
      confirmEditSaveVisible: false,
      contentData: {configType: 1},
      contentDataTemp: {configType: 1},
    }
  },
  computed: {        
      ...mapGetters(['basedataGetName']),
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    handleSearch() {
      sysdateconfig.list({
                        configType: 1,
                        pageNo: 1,
                        pageSize: 1
                      })
                    .then(res => {
                      if(res.records.length > 0) {
                        this.contentDataTemp = res.records[0];
                        this.contentData = _.clone(this.contentDataTemp);
                      }
                    })
    },
    handleEditClick() {
      this.editVisible = true;
    },
    handleCancelEditClick() {
      this.contentData = _.clone(this.contentDataTemp)
      this.editVisible = false;
    },
    handleEditConfirmClick() {
      this.$refs['form'].validate((valid) => {
                if(valid) {
                    this.confirmEditSaveVisible = true;
                }
                else {
                    this.$message.error(this.basedataGetName('SysErrorTip',1));
                }
            })  
    },
    handlerEditSaveConfirmOK() {
      let funName = this.contentData.id? 'edit' : 'add';
      sysdateconfig[funName](this.contentData)
                    .then(res => {
                        this.$message.success('编辑季度申请开放周期成功');
                        this.contentDataTemp = _.clone(this.contentData);
                        this.confirmEditSaveVisible = false;
                        this.editVisible = false;
                    })
    }
  },  
  mounted() {      
    this.initBaseDataByTypes(['SysErrorTip'])
        .then(() => {
          this.handleSearch();  
        })
  }
};
</script>

<style lang="less" scoped>
  .operate {
    margin-top: 20px;
    text-align: center;
  }
  
  .inline-items {
    label {
      width: 180px;
    }
    div {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?1403edd2